import { pageInfo, importTransportPlan, exportSchOrderForPlanImport, createScheduValidateParam, createScheduInfo, uploadFile, assignCarrier, initSegmentation, scheduSplitParagraphs, getCallSctRdc, scheduSplitQuantityValidateParam, scheduSplitQty, returnScheduSplitQty, returnschedusplitParagraphs, schedulingJobBillList, schedulingCreateValidateParam } from './../api';
import {addData} from "../../../mdm/truck/api";
import {addDriverData} from "../../../mdm/driver/api";
import {
  getTruckListByCarrierNo,
  getDriverListByCarrierNo,
  getCarTypeList,
  getListCarrier,
  getListShipType,
  getCarrierDpList,
  listShipper,
  listProject
} from '../../../../api/index'
import { companyListData } from "../../../mdm/company/api";
const reservation = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    addValidateParamResp: null,
    addSubmitResp: null,
    saveTruckResp: null,
    saveDriverResp: null,
    truckDataResp: null,
    driverDataResp: null,
    carTypeDataResp: null,
    importDataObj: null,
    exportResp: null,
    uploadFileObj: null,
    uptCarrierObj: null,
    carrierObj: null,
    shipTypeObj: null,
    segmentationInitObj: null,
    segmentationSubmitObj: null,
    dpObj: null,
    callSctRdcTableObj: null,
    companyObj: null,
    weightDataObj: null,
    weightSubmit: null,
    retrunSplitObj: null,
    returnSegmentationObj: null,
    shiperNameObj: null,
    shiperProjectObj: null,
    pageOrderResp: null,
    pageOrderTotal: null,
    orderValidate: null
  },
  mutations: {

    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || [])
        .map(item=>({...item,btns:[{disabled: item.splitStatus != '10' ? true : false,show:true},{disabled: item.splitStatus != '20' ? true : false,show:true}]}));
    },
    ADD_VALIDATE_PARAM(state, data) {
      state.addValidateParamResp = data;
    },
    ADD_SUBMIT(state, data) {
      state.addSubmitResp = data;
    },
    SAVE_TRUCK_DATA(state, data) {
      state.saveTruckResp = data;
    },
    SAVE_DRIVER_DATA(state, data) {
      state.saveDriverResp = data;
    },
    TRUCK_LIST_BY_CARRIERNO(state, data) {
      state.truckDataResp = data.obj;
    },
    DRIVER_LIST_BY_CARRIERNO(state, data) {
      state.driverDataResp = data.obj;
    },
    CAR_TYPE_LIST(state, data) {
      state.carTypeDataResp = data.obj;
    },
    IMPORT_TRANSPORT_PLAN(state, data) {
      state.importDataObj = data;
    },
    EXPORT_SCHORDER_FOR_PLAN_IMPORT(state, data) {
      state.exportResp = data;
    },
    //上传附件
    UPLOAD_FILE(state, data) {
      state.uploadFileObj = data;
    },
    //指派承运商提交
    ASSIGN_CARRIER(state, data) {
      state.uptCarrierObj = data;
    },
    //承运商下拉框数据
    GET_LIST_CARRIER(state, data) {
      state.carrierObj = data.obj;
    },
    //运输方式下拉框数据
    GET_LIST_SHIP_TYPE(state, data) {
      state.shipTypeObj = data.obj;
    },
    //分段初始化前置校验
    INIT_SEGMENTATION(state, data) {
      state.segmentationInitObj = data;
    },
    //分段提交
    SCHEDU_SPLIT_PARAGRAPHS(state, data) {
      state.segmentationSubmitObj = data;
    },
    //分拨点
    GET_CARRIER_DP_LIST(state, data) {
      state.dpObj = data.obj;
    },
    //rdc详情
    GET_CALL_SCT_RDC(state, data) {
      state.callSctRdcTableObj = data;
    },
    //机构
    LIST_COMPANY(state, data) {
      state.companyObj = data.obj;
    },
    /**
     * 分量
     * @param state
     * @param data
     * @constructor
     */
    SCHEDU_SPLIT_QUANTITY_VALIDATE_PARAM(state, data) {
      state.weightDataObj = data;
    },
    /**
     * 分量提交
     * @param state
     * @param data
     * @constructor
     */
    SCHEDU_SPLIT_QTY(state, data) {
      state.weightSubmit = data;
    },
    /**
     * 撤销分量
     * @param state
     * @param data
     * @constructor
     */
    RETURN_SCHEDU_SPLIT_QTY(state, data) {
      state.retrunSplitObj = data;
    },
    /**
     * 撤销分段
     * @param state
     * @param data
     * @constructor
     */
    RETURN_SEGMENTATION(state, data) {
      state.returnSegmentationObj = data;
    },
    /**
     * 货主
     * @param state
     * @param data
     * @constructor
     */
    GET_LIST_SHIPPER(state, data) {
      state.shiperNameObj = data.obj;
    },
    /**
     * 项目名称
     * @param state
     * @param data
     * @constructor
     */
    GET_LIST_PROJECT(state, data) {
      state.shiperProjectObj = data.obj;
    },

    /**
     * 订单查询-分页
     * @param state
     * @param data
     * @constructor
     */
    SCHEDULING_JOB_BILL_LIST(state, data) {
      state.pageOrderTotal = data.total;
      state.pageOrderResp = (data.obj || [])
    },
    /**
     * 增加订单校验
     * @param state
     * @param data
     * @constructor
     */
    SCHEDULING_CREATE_VALIDATE_PARAM(state, data) {
      state.orderValidate = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    /**
     * 新增前置校验
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async createScheduValidateParam({ commit }, obj) {
      let resp = await createScheduValidateParam(obj);
      commit('ADD_VALIDATE_PARAM', resp);
    },
    /**
     * 保存提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async createScheduInfo({ commit }, obj) {
      let resp = await createScheduInfo(obj);
      commit('ADD_SUBMIT', resp);
    },
    /**
     * 保存车辆
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async saveTruckData({ commit }, obj) {
      let resp = await addData(obj);
      commit('SAVE_TRUCK_DATA', resp);
    },
    /**
     * 保存司机
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async saveDriverData({ commit }, obj) {
      let resp = await addDriverData(obj);
      commit('SAVE_DRIVER_DATA', resp);
    },

    /**
     * 获取车辆信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getTruckListByCarrierNo({ commit }, obj) {
      let resp = await getTruckListByCarrierNo(obj);
      commit('TRUCK_LIST_BY_CARRIERNO', resp);
    },
    /**
     * 获取司机信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getDriverListByCarrierNo({ commit }, obj) {
      let resp = await getDriverListByCarrierNo(obj);
      commit('DRIVER_LIST_BY_CARRIERNO', resp);
    },
    /**
     * 获取车辆类型信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getCarTypeList({ commit }, obj) {
      let resp = await getCarTypeList(obj);
      commit('CAR_TYPE_LIST', resp);
    },
    /**
     * 导入
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async importTransportPlan({ commit }, obj) {
      let resp = await importTransportPlan(obj);
      commit('IMPORT_TRANSPORT_PLAN', resp);
    },
    /**
     * 导出
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async exportSchOrderForPlanImport({ commit }, obj) {
      let resp = await exportSchOrderForPlanImport(obj);
      commit('EXPORT_SCHORDER_FOR_PLAN_IMPORT', resp);
    },
    /**
     * 上传附件
     */
    async uploadFile({commit}, obj) {
      let resp = await uploadFile(obj);
      commit('UPLOAD_FILE', resp);
    },
    /**
     * 指派承运商提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async assignCarrier({commit}, obj) {
      let resp = await assignCarrier(obj);
      commit('ASSIGN_CARRIER', resp);
    },
    /**
     * 获取承运商下拉框数据
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getListCarrier({commit}, obj) {
      let resp = await getListCarrier(obj);
      commit('GET_LIST_CARRIER', resp);
    },
    /**
     * 运输方式
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getListShipType({commit}, obj) {
      let resp = await getListShipType(obj);
      commit('GET_LIST_SHIP_TYPE', resp);
    },
    /**
     * 分段初始化前置校验
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async initSegmentation({commit}, obj) {
      let resp = await initSegmentation(obj);
      commit('INIT_SEGMENTATION', resp);
    },
    /**
     * 分段提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async scheduSplitParagraphs({commit}, obj) {
      let resp = await scheduSplitParagraphs(obj);
      commit('SCHEDU_SPLIT_PARAGRAPHS', resp);
    },
    /**
     * 分拨点下拉框
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getCarrierDpList({commit}, obj) {
      let resp = await getCarrierDpList(obj);
      commit('GET_CARRIER_DP_LIST', resp);
    },
    /**
     * 运输信息->点击发货方-打开预约量弹出框查询详情,这里只针对亿滋
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getCallSctRdc({commit}, obj) {
      let resp = await getCallSctRdc(obj);
      commit('GET_CALL_SCT_RDC', resp);
    },
    /**
     * 机构初始化下拉框数据
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async listCompany({commit}, obj) {
      let resp = await companyListData(obj);
      commit('LIST_COMPANY', resp);
    },
    /**
     * 分量初始化校验
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async scheduSplitQuantityValidateParam({commit}, obj) {
      let resp = await scheduSplitQuantityValidateParam(obj);
      commit('SCHEDU_SPLIT_QUANTITY_VALIDATE_PARAM', resp);
    },
    /**
     * 分量提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async scheduSplitQty({commit}, obj) {
      let resp = await scheduSplitQty(obj);
      commit('SCHEDU_SPLIT_QTY', resp);
    },
    /**
     * 取消分量
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async returnScheduSplitQty({commit}, obj) {
      let resp = await returnScheduSplitQty(obj);
      commit('RETURN_SCHEDU_SPLIT_QTY', resp);
    },
    /**
     * 撤销分段
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async returnschedusplitParagraphs({commit}, obj) {
      let resp = await returnschedusplitParagraphs(obj);
      commit('RETURN_SEGMENTATION', resp);
    },
    /**
     * 货主
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getListShipper({commit}, obj) {
      let resp = await listShipper(obj);
      commit('GET_LIST_SHIPPER', resp);
    },
    /**
     * 项目名称
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getListProject({commit}, obj) {
      let resp = await listProject(obj);
      commit('GET_LIST_PROJECT', resp);
    },
    //订单查询数据
    async schedulingJobBillList({commit}, obj) {
      let resp = await schedulingJobBillList(obj);
      commit('SCHEDULING_JOB_BILL_LIST', resp);
    },
    //增加订单校验
    async schedulingCreateValidateParam({commit}, obj) {
      let resp = await schedulingCreateValidateParam(obj);
      commit('SCHEDULING_CREATE_VALIDATE_PARAM', resp);
    },
  }
}
export default reservation



// WEBPACK FOOTER //
// ./src/page/transport/reservation/store/reservation.store.js